<template>
  <div>
    <v-dialog
      :value="value"
      width="1000"
      @input="$emit('input',$event)"
    >
      <v-card
        v-if="whsItem"
        light
        style="font-size: 14px;"
      >
        <v-toolbar
          dark
          dense
          color="blue"
        >
          <v-toolbar-title>
            淘宝新增地址範例
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              @click.native="$emit('input',false)"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <div style="position: relative;">
            <img
              src="./images/taobao-addr-exmp.png"
              width="900"
              style="pointer-events: none;"
            >
            <span style="position: absolute;width: 300px;left:365px;top:365px;">
              {{ whsItem.province }} /
              {{ whsItem.city }} /
              {{ whsItem.district }}
              <span v-if="whsItem.street">  / {{ whsItem.street }}</span>
            </span>
            <span style="position: absolute;width: 300px;left:365px;top:425px;">
              {{ whsItem.desc }}{{ whsItem.formatAddr.uidNum }}
            </span>
            <span style="position: absolute;width: 300px;left:365px;top:498px;">
              {{ whsItem.formatAddr.postcode }}
            </span>
            <span style="position: absolute;width: 300px;left:365px;top:544px;">
              {{ whsItem.formatAddr.name }}
            </span>
            <span style="position: absolute;width: 300px;left:513px;top:592px;">
              {{ whsItem.formatAddr.phone }}
            </span>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    whsItem: Object,
    value: Boolean,
  },
  data () {
    return {
      switch1: true,
    }
  }
}
</script>
